import { render, staticRenderFns } from "./wikipedia-h5.vue?vue&type=template&id=85b747f6&scoped=true"
import script from "./wikipedia-h5.vue?vue&type=script&lang=js"
export * from "./wikipedia-h5.vue?vue&type=script&lang=js"
import style0 from "./wikipedia-h5.vue?vue&type=style&index=0&id=85b747f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b747f6",
  null
  
)

export default component.exports